/*eslint-disable react-perf/jsx-no-jsx-as-prop */
import { Navigate, Route } from 'react-router-dom'

import ImpressView from './screens/ImpressView'
import NotFoundView from './screens/NotFoundView'
import AuthView from './screens/AuthView'
import RestaurantsView from './screens/RestaurantsView'
import SettlementMapView from './screens/SettlementMapView'
import ApiMonitoringView from './screens/ApiMonitoringView'
import DocumentsView from './screens/DocumentsView'
type Route = {
	path: string
	element: JSX.Element
}

export const RESTAURANTS_PATH = '/restaurants'
export const STATISTICS_PATH = '/statistics'
export const API_MONITORING_PATH = '/api-monitoring'
export const DOCUMENTS_PATH = '/documents'

export const routes: Route[] = [
	{
		path: '/',
		element: (
			<AuthView>
				<Navigate to={RESTAURANTS_PATH} replace />
			</AuthView>
		),
	},
	{
		path: RESTAURANTS_PATH,
		element: (
			<AuthView>
				<RestaurantsView />
			</AuthView>
		),
	},
	{
		path: STATISTICS_PATH,
		element: (
			<AuthView>
				<SettlementMapView />
			</AuthView>
		),
	},
	{
		path: API_MONITORING_PATH,
		element: (
			<AuthView>
				<ApiMonitoringView />
			</AuthView>
		),
	},
	{
		path: DOCUMENTS_PATH,
		element: (
			<AuthView>
				<DocumentsView />
			</AuthView>
		),
	},
	{
		path: '/impress',
		element: <ImpressView />,
	},
	{
		path: '*',
		element: <NotFoundView />,
	},
]

type UserType = 'LOGGED_OUT'

const getRoutes = (type?: UserType) => {
	return type === 'LOGGED_OUT' ? routes : []
}

export default getRoutes
